// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"486":"4c0a084b","873":"b512aa65","985":"79d1e90a"}[chunkId] + ".chunk.js";
};